export { PrintView, type PrintViewProps } from './print-view';
